import { useState } from "react";
import { Select } from "../organisms/Select";
import { useChangeStageMutation } from "@/app/leads/leads.api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { toasts } from "@/shared/utils/toasts";

interface optionsProps {
  name: string;
  id: string;
}

export type ColumnDropdownProps = {
  options: optionsProps[];
  selected: string;
  person: any;
  lastPeople: any;
};

const ColumnDropdown: React.FC<ColumnDropdownProps> = ({
  options,
  person,
  lastPeople,
}) => {
  const [changeStage, { isLoading }] = useChangeStageMutation();

  const [selectEtape, setSelectEtape] = useState<any>({
    id: person?.stages,
    name: options?.find((option) => option?.id === person?.stages)?.name,
  });

  const handleSelectEtape = async (select: any) => {
    try {
      setSelectEtape(select);
      await changeStage({
        leadId: person.id,
        stages: select.id,
      }).unwrap();
      toasts.success("Actualización", "Cambio realiado con éxito");
    } catch (error) {
      console.error(error);
      toasts.danger("Error", "Cambio no realiado");
    }
  };

  if (isLoading) {
    return (
      <td className="whitespace-nowrap px-3 py-10 text-sm text-gray-500 min-w-60 flex">
        <div className="w-full flex justify-center items-center">
          <FontAwesomeIcon icon={faLoader} className="animate-spin h-5 w-5" />
        </div>
      </td>
    );
  }

  return (
    <td className="whitespace-nowrap px-3 py-10 pr-10 text-sm text-gray-500 min-w-60 flex items-start  ">
      <div className="w-full">
        <Select
          name=""
          reverse={lastPeople?.[lastPeople.length - 1]?.id === person?.id}
          selected={selectEtape}
          setSelected={handleSelectEtape}
          options={options}
          tittle=""
        />
      </div>
    </td>
  );
};

export default ColumnDropdown;
